import {SODeleteTopic} from '../../core/topic/so-delete-topic';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteTopic extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteTopic;
}